fragment DripSequenceStubFragment on Campaign {
    id
    name
    status
    startTrigger {
        id
        type
        conditions {
            type
            config {
                ... on ConditionConfigEntityFilter {
                    filter {
                        ... on EntityFilterFieldConfigRelationship {
                            relationshipAnyAll
                            relationshipData
                        }
                        ... on EntityFilterFieldConfigEnum {
                            enumValue
                            enumIsNot
                        }
                    }
                }
                ... on ConditionConfigTag {
                    tags
                }
                ... on ConditionConfigAudience {
                    audiences
                }
            }
        }
        humanReadableTitle
        humanReadableSubtitle
    }
    htmlUrlPath
    creatorUser {
        id
        name
    }
    createdTime
    modifiedTime
    lastStatusChangeTime
    editions {
        totalCount
    }
    type
    deletedTime
    status
    isRemovable
    engagementStats {
        totalSentCount
        replyRate
        replyCount
        clickCount
        clickRate
        openCount
        openRate
        permanentBounceRate
        permanentBounceCount
        unsubscribeRate
        unsubscribeCount
        latestDeliveryTime
        dripProgressionTotalRecipients
        dripProgressionsStopped
        dripProgressionsGoalMet
        dripProgressionsGoalMetRate
        dripProgressionsReceivedEveryMessageRate
    }
    from {
        id
        status
        emailAddress {
            display
            formatted
        }
    }
}
